export default function mediaItem() {
  return {
    _id: false,
    type: 'droplet.mediaItem',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    groupHeader: 'More From These Groups',
    item: null,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/media-item/droplet.schema.js